import React from 'react';
import IdleTimer from 'react-idle-timer';
import Navbar from '../../components/Navbar/Navbar';
import ErrorBoundary from '../../components/ErrorBoundary';
import Routes from '../../Routes';
import SideMenu from './SideMenu/SideMenu';
import useLanding from './hooks/useLanding';

const Landing = () => {
    const { onIdle, onAction, user, idleTimer } = useLanding();

    return (
        <div
            className={`App ${!user.isSignedIn ? 'BlueBackground' : null}`}
            data-testid="appContainer">
            <IdleTimer
                key="idleTimer"
                startOnMount={true}
                //@ts-ignore
                ref={idleTimer}
                element={document}
                onActive={() => onAction()}
                onIdle={() => onIdle()}
                timeout={600000}
            />
            {user.isSignedIn ? (
                <>
                    <Navbar />
                    <SideMenu>
                        <ErrorBoundary>
                            <Routes />
                        </ErrorBoundary>
                    </SideMenu>
                </>
            ) : (
                <>
                    <ErrorBoundary>
                        <Routes />
                    </ErrorBoundary>
                </>
            )}
        </div>
    );
};

export default Landing;
